module.exports = __webpack_public_path__ + "img/poster_4.0bfe060e.png";